



























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectZiduanQitayongyao extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private ziduan: any;
  private defaultValue: any = "";
  private ziduanChange() {
    this.$emit("update:ziduanChange", this.ziduan);
  }
}
